import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'

function Fecha(props) {
    return (
        <Fragment><br/>
        <div id="fecha" className="col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 mt-3">
          <h4>{props.numeroDeDia}</h4>
        </div>


        </Fragment>
    );
};


export default withRouter(Fecha)